<!--@format-->
<template>
    <div class="account-company-preferred-currency-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Edit Preferred Currency</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-svg v-if="isLoading" />
                <div class="preferred-currency-container" v-else>
                    <label for="">Select a currency</label>
                    <autocomplete-dropdown-currency v-model="currencySelected" :items="items" />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-pop-submit back-button" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button :disabled="isLoading" @click="handleSaveCurrency"
                        >Select a currency</app-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AutocompleteDropdownCurrency = () =>
    import('@/components/currency/autocomplete-dropdown-currency');
const LoadingSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';
import { AccountCurrencyConfigurationService } from '@/scripts/services/company-account-settings/account-currency-configuration-service.js';
import { CurrencyMixin } from '@/mixins/currency-mixin';
import { CurrencyService } from '@/scripts/services/company-account-settings/currency-service.js';

export default {
    name: 'account-company-preferred-currency-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'autocomplete-dropdown-currency': AutocompleteDropdownCurrency,
        'loading-svg': LoadingSvg,
    },

    mixins: [CurrencyMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            accountId: this.widget.accountId,
            items: [],
            currencySelected: this.widget.options.currencySelected,
        };
    },

    created() {
        this.getAllCurrencies();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        handleSaveCurrency() {
            AccountCurrencyConfigurationService.post(this.accountId, {
                currencyISOCode: this.currencySelected.isoCode,
            })
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        "You've successfully updated the currency.",
                    );
                    EventBus.$emit('update-currency-selected', this.currencySelected);
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Error while saving currency.', { error });
                });
        },

        getAllCurrencies() {
            this.isLoading = true;
            CurrencyService.getAllCurrencies()
                .then(({ data: { data } }) => {
                    this.items = data.map(this.mapItem);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        mapItem(item) {
            return {
                id: item.Id,
                name: item.Name,
                symbol: item.Symbol,
                isoCode: item.ISOCode,
            };
        },
    },
};
</script>

<style>
.account-company-preferred-currency-widget .app-button.cancel-pop-submit.back-button {
    width: 127px;
    height: 40px;
}
</style>
